<template>
    <div>
        <div class="row">
            <div class="col-lg-7">
                <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                    <template slot="header">
                        <th :class="StyleTh+' text-center'">#</th>
                        <!-- <th :class="StyleTh">Nombre de la Imagen</th> -->
				        <th :class="StyleTh" width="30%">Unidad</th>
                        <th :class="StyleTh" width="25%">Sub Unidad</th>
                        <th :class="StyleTh+' text-center'">Acciones</th>
                    </template>
                    <template slot="body">
                        <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                            <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                            <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                            <td><p :class="StyleTd">{{ lista.Cantidad + ' ' +  lista.SubUnidad}}</p></td>
                            <td class="align-middle text-end">
                                <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="false" :pId="lista.IdMaterialPresentacion" :pGoRoute="ConfigList.GoRoute" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                                    <template slot="btnaccion">
                                        <button type="button" @click="VerProveedores(lista.IdMaterialPresentacion)" class="btn btn-link text-primary px-3 mb-0 mr-1">
                                            <i class="fas fa-eye text-primary me-2" aria-hidden="true"></i> Ver
                                        </button>
                                    </template>
                                </CBtnAccion>
                            </td>
                        </tr>
                        <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="4"></CSinRegistros>
                    </template>
                </CList>
            </div>

            <div class="col-lg-5">
                <div class="card">
                    <div class="card-header">
                        <h6>Proveedores</h6>
                    </div>
                    <div class="card-body height-300">
                        <div class="table-responsive">
                            <CLoader :pConfigLoad="ConfigLoadProveedores">
                                <template slot="BodyFormLoad">
                                    <table class="table align-items-center mb-0">
                                        <thead>
                                            <tr>
                                                <th :class="StyleTh+' text-center'" width="5%">#</th>
                                                <th :class="StyleTh" width="60%">Nombre</th>
                                                <th :class="StyleTh" width="20%">Precio</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(lista,index) in Proveedores" :key="index">
                                                <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                                                <td><h6 :class="StylePr">{{lista.proveedor.NombreComercial}}</h6></td>
                                                <td><p :class="StyleTd">$ {{ lista.Costo}}</p></td>
                                            </tr>
                                            <CSinRegistros :pContIF="Proveedores.length" :pColspan="3"></CSinRegistros>
                                        </tbody>
                                    </table>
                                </template>
                            </CLoader> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import Form from '@/views/modulos/almacen/material/Form.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionPresentacion';

export default {
    name: 'ListaPresentacion',
    props: ['pObjEnviado'],
    components: {
        // Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Listado',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Presentaciones',
                GoRoute:'presentacionform',
                Obj:{}
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Proveedores:[],
            ConfigLoadProveedores:{
                ShowLoader:false
            },
            ObjArticuloAlmacen: {}
        }
    },
    methods: {
        async Lista(){
            this.ConfigList.ShowLoader = true;

            await this.$http.get("materialespresentacion",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdArticuloAlmacen: this.ObjArticuloAlmacen.IdArticuloAlmacen,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.ConfigList.Obj.pListaFiltro = this.ListaArrayRows;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('materialespresentacion/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                        this.Proveedores=[];
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'material',params:{}});
        },
        VerProveedores(Id){
            this.ConfigLoadProveedores.ShowLoader=true;
            this.$http.get("materialespresentacionproveedor",{
                params:{
                    IdMaterialPresentacion:Id
                }
            }
            ).then((res)=>{
                this.Proveedores = res.data.data;
            }).finally(()=>{
                this.ConfigLoadProveedores.ShowLoader=false;
            })
        }
    },
    created(){
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objArticuloAlmacen',JSON.stringify(this.pObjEnviado));
        }

        this.ObjArticuloAlmacen = JSON.parse(sessionStorage.getItem('objArticuloAlmacen'));
        this.ConfigList.Title = this.ConfigList.Title+' '+this.ObjArticuloAlmacen.Nombre;

        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>